// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"a22b00376700a8a4f8c2","655":"5dffee87cb2e4d8f407d"}[chunkId] + ".js";
};